export const COACHEE_ONBOARDING_ERROR = 'COACHEE_ONBOARDING_ERROR';
export const COACHEE_ONBOARDING_LOADING = 'COACHEE_ONBOARDING_LOADING';
export const COACHEE_ONBOARDING_DISPLAY_NEXT_SCREEN = 'COACHEE_ONBOARDING_DISPLAY_NEXT_SCREEN';
export const COACHEE_ONBOARDING_GET = 'COACHEE_ONBOARDING_GET';
export const COACHEE_ONBOARDING_UPDATE_COMPLETED_STEP = 'COACHEE_ONBOARDING_UPDATE_COMPLETED_STEP';
export const COACHEE_ONBOARDING_TOGGLE_STRENGTH_REPORT_SCREEN =
  'COACHEE_ONBOARDING_TOGGLE_STRENGTH_REPORT_SCREEN';
export const COACHEE_ONBOARDING_SKIP_STEP = 'COACHEE_ONBOARDING_SKIP_STEP';
export const COACHEE_ONBOARDING_STORE_SKIPPED_INDEXES = 'COACHEE_ONBOARDING_STORE_SKIPPED_INDEXES';
